import qs from 'qs'

import { wrapCall, callGet } from './helpers'

//* ~~~~~~ PEER CHAT ~~~~~~

// Gets all activity between caller and another user
export const fetchPeerChatTimeline = async (id, limit, after) => {
  const query = qs.stringify({ limit, after }, { addQueryPrefix: true })

  const {
    data,
    pagination: { next }
  } = await wrapCall({
    method: callGet,
    uri: `/timeline/${id}${query}`,
    noData: true
  })

  return { data, next }
}

//* ~~~~~~ GROUP CHAT ~~~~~~

// Gets activity for a session
export const fetchSessionTimeline = async (id, limit, after) => {
  const query = qs.stringify({ limit, after }, { addQueryPrefix: true })

  const {
    data,
    pagination: { next }
  } = await wrapCall({
    method: callGet,
    uri: `/sessions/${id}/timeline${query}`,
    noData: true
  })

  return { data, next }
}

//* ~~~~~~ NORMAL SESSION ~~~~~~

// Gets activity for a user
export const fetchUserTimeline = async (id, limit, after) => {
  const query = qs.stringify({ limit, after }, { addQueryPrefix: true })

  const {
    data,
    pagination: { next }
  } = await wrapCall({
    method: callGet,
    uri: `/users/${id}/timeline${query}`,
    noData: true
  })

  return { data, next }
}
